import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'Tabs',
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss'
})
export class TabsComponent {
  @Input() tabs: { label: string; content: any; disabled?: boolean }[] = [];
  @Input() selectedIndex: number = 0;
  @Output() tabChange = new EventEmitter<number>();

  onTabChange(event: any): void {
    this.tabChange.emit(event.index);
  }
}
